import PhotoWithBackdrop from '../ui/PhotoWithBackdrop';
import { motion } from 'framer-motion';

export default function FamilyTour() {
  return (
    <section className="bg-[#F9E392] py-16 px-5 relative font-nunito rounded-lg overflow-hidden" style={{fontFamily: 'Nunito, sans-serif'}}>
      {/* Floating bubbles background */}
      <motion.div
        className="absolute top-1/6 left-1/6 w-3 h-3 bg-white rounded-full opacity-60"
        animate={{ 
          y: [0, -30, 0],
          x: [0, 15, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{ 
          duration: 4,
          repeat: Infinity,
          ease: "easeOut"
        }}
      />
      <motion.div
        className="absolute top-1/4 right-1/4 w-2 h-2 bg-white rounded-full opacity-70"
        animate={{ 
          y: [0, -25, 0],
          x: [0, -10, 0],
          scale: [1, 1.4, 1]
        }}
        transition={{ 
          duration: 3.5,
          repeat: Infinity,
          ease: "easeOut",
          delay: 0.5
        }}
      />
      <motion.div
        className="absolute top-2/8 left-1/3 w-4 h-4 bg-white rounded-full opacity-50"
        animate={{ 
          y: [0, -35, 0],
          x: [0, 8, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 5,
          repeat: Infinity,
          ease: "easeOut",
          delay: 1
        }}
      />
      <motion.div
        className="absolute top-2/5 right-1/5 w-1.5 h-1.5 bg-white rounded-full opacity-80"
        animate={{ 
          y: [0, -20, 0],
          x: [0, -5, 0],
          scale: [1, 1.5, 1]
        }}
        transition={{ 
          duration: 2.5,
          repeat: Infinity,
          ease: "easeOut",
          delay: 1.5
        }}
      />
      <motion.div
        className="absolute top-1/2 left-10 w-2.5 h-2.5 bg-white rounded-full opacity-55"
        animate={{ 
          y: [0, -28, 0],
          x: [0, 12, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{ 
          duration: 4.5,
          repeat: Infinity,
          ease: "easeOut",
          delay: 0.8
        }}
      />
      <motion.div
        className="absolute top-3/5 right-1/3 w-3.5 h-3.5 bg-rose-300 rounded-full opacity-45"
        animate={{ 
          y: [0, -32, 0],
          x: [0, -8, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          duration: 6,
          repeat: Infinity,
          ease: "easeOut",
          delay: 2
        }}
      />
      <motion.div
        className="absolute top-1/4 left-6/10 w-1 h-1 bg-rose-300 rounded-full opacity-90"
        animate={{ 
          y: [0, -18, 0],
          x: [0, 6, 0],
          scale: [1, 1.6, 1]
        }}
        transition={{ 
          duration: 3,
          repeat: Infinity,
          ease: "easeOut",
          delay: 0.3
        }}
      />
      <motion.div
        className="absolute top-6/4 right-1/4 w-2 h-2 bg-rose-300 rounded-full opacity-65"
        animate={{ 
          y: [0, -26, 0],
          x: [0, -12, 0],
          scale: [1, 1.4, 1]
        }}
        transition={{ 
          duration: 4.2,
          repeat: Infinity,
          ease: "easeOut",
          delay: 1.2
        }}
      />
      <motion.div
        className="absolute top-4/5 left-1/3 w-3 h-3 bg-blue-300 rounded-full opacity-50"
        animate={{ 
          y: [0, -30, 0],
          x: [0, 10, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 5.5,
          repeat: Infinity,
          ease: "easeOut",
          delay: 0.7
        }}
      />
      <motion.div
        className="absolute top-5/6 right-1/5 w-1.5 h-1.5 bg-white rounded-full opacity-75"
        animate={{ 
          y: [0, -22, 0],
          x: [0, -7, 0],
          scale: [1, 1.5, 1]
        }}
        transition={{ 
          duration: 3.8,
          repeat: Infinity,
          ease: "easeOut",
          delay: 1.8
        }}
      />

      <motion.div
        className="absolute top-5/6 right-2/5 w-1.5 h-1.5 bg-white rounded-full opacity-75"
        animate={{ 
          y: [0, -22, 0],
          x: [0, -7, 0],
          scale: [1, 1.5, 1]
        }}
        transition={{ 
          duration: 3.8,
          repeat: Infinity,
          ease: "easeOut",
          delay: 1.8
        }}
      />
      {/* Animated Wave at the top */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none" style={{height: '60px'}}>
        <motion.svg 
          viewBox="0 0 2000 60" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className="w-full h-full"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.path 
            d="M0,30 C500,10 1000,50 2000,30" 
            stroke="white" 
            strokeWidth="3" 
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, ease: "easeOut" }}
          />
          <motion.path 
            d="M0,35 C500,15 1000,55 2000,35" 
            stroke="white" 
            strokeWidth="2" 
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, delay: 0.3, ease: "easeOut" }}
          />
          <motion.path 
            d="M0,40 C500,20 1000,60 2000,40" 
            stroke="white" 
            strokeWidth="1" 
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, delay: 0.6, ease: "easeOut" }}
          />
        </motion.svg>
      </div>
      
      <div className="max-w-6xl mx-auto" style={{display: 'grid', gridTemplateColumns: '3fr 1fr', gap: '3rem', alignItems: 'stretch', minHeight: '400px'}}>
        <div className="text-dblue flex flex-col justify-center pr-8">
          <motion.h2 
            className="text-3xl md:text-4xl font-bold mb-6"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Family Tour of the Centre and Meeting with Our Director
          </motion.h2>
          
          <div className="space-y-4 text-black">
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            >
              Families can visit by appointment in the morning (9:30 AM to 12:00 PM) or afternoon (3:30 PM to 4:30 PM).
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
            >
              The tour will be conducted by <strong>Ms Reima</strong>.
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
            >
              For special appointments, please contact us at <strong>(604) 986-2388</strong>.
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8, ease: "easeOut" }}
            >
              After the tour, families will meet the Director to discuss philosophy and programming. 
              We suggest visiting more than one centre for an informed decision.
            </motion.p>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center gap-8 w-full pl-4">
          {/* Staff Photos using PhotoWithBackdrop with staggered animations */}
          <motion.div 
            className="w-full max-w-sm"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
          >
            <PhotoWithBackdrop src="/images/msreima.jpg" alt="Ms Reima" square={true} size="md" borderColor="border-white" particleColor1='bg-white' particleColor2='bg-white'/>
          </motion.div>
          
          <motion.div 
            className="w-full max-w-sm"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
          >
            <PhotoWithBackdrop src="/images/msmorris.jpg" alt="Ms Morris" square={true} size="md" borderColor="border-white" particleColor1='bg-white' particleColor2='bg-white'/>
          </motion.div>
        </div>
      </div>

      {/* Animated Wave at the bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" style={{height: '60px'}}>
        <motion.svg 
          viewBox="0 0 2000 60" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className="w-full h-full"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.path 
            d="M0,30 C500,50 1000,10 2000,30" 
            stroke="white" 
            strokeWidth="3" 
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, ease: "easeOut" }}
          />
          <motion.path 
            d="M0,25 C500,45 1000,5 2000,25" 
            stroke="white" 
            strokeWidth="2" 
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, delay: 0.3, ease: "easeOut" }}
          />
          <motion.path 
            d="M0,20 C500,40 1000,0 2000,20" 
            stroke="white" 
            strokeWidth="1" 
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, delay: 0.6, ease: "easeOut" }}
          />
        </motion.svg>
      </div>
    </section>
  );
}